import React, { createContext, useContext, useReducer } from 'react';

// 初始状态
const initialState = {
  campaignInfo: {
    campaignName: '',
    productDescription: '',
    landingPage: '',
    files: [] // 真正的File对象数组
  },
  audienceContent: {},
  budgetData: {},
  currentStep: 1
};

// Actions
const ACTIONS = {
  UPDATE_CAMPAIGN_INFO: 'UPDATE_CAMPAIGN_INFO',
  UPDATE_AUDIENCE_CONTENT: 'UPDATE_AUDIENCE_CONTENT', 
  UPDATE_BUDGET_DATA: 'UPDATE_BUDGET_DATA',
  SET_FILES: 'SET_FILES',
  ADD_FILES: 'ADD_FILES',
  REMOVE_FILE: 'REMOVE_FILE',
  SET_CURRENT_STEP: 'SET_CURRENT_STEP',
  RESET: 'RESET'
};

// Reducer
const campaignReducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.UPDATE_CAMPAIGN_INFO:
      return {
        ...state,
        campaignInfo: { ...state.campaignInfo, ...action.payload }
      };
    
    case ACTIONS.SET_FILES:
      return {
        ...state,
        campaignInfo: { ...state.campaignInfo, files: action.payload }
      };
    
    case ACTIONS.ADD_FILES:
      return {
        ...state,
        campaignInfo: { 
          ...state.campaignInfo, 
          files: [...state.campaignInfo.files, ...action.payload] 
        }
      };
    
    case ACTIONS.REMOVE_FILE:
      return {
        ...state,
        campaignInfo: { 
          ...state.campaignInfo, 
          files: state.campaignInfo.files.filter((_, index) => index !== action.payload) 
        }
      };
    
    case ACTIONS.UPDATE_AUDIENCE_CONTENT:
      return {
        ...state,
        audienceContent: { ...state.audienceContent, ...action.payload }
      };
    
    case ACTIONS.UPDATE_BUDGET_DATA:
      return {
        ...state,
        budgetData: { ...state.budgetData, ...action.payload }
      };
    
    case ACTIONS.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      };
    
    case ACTIONS.RESET:
      return initialState;
    
    default:
      return state;
  }
};

// Context
const CampaignContext = createContext();

// Provider组件
export const CampaignProvider = ({ children }) => {
  const [state, dispatch] = useReducer(campaignReducer, initialState);

  // Action creators
  const actions = {
    updateCampaignInfo: (data) => dispatch({ type: ACTIONS.UPDATE_CAMPAIGN_INFO, payload: data }),
    setFiles: (files) => dispatch({ type: ACTIONS.SET_FILES, payload: files }),
    addFiles: (files) => dispatch({ type: ACTIONS.ADD_FILES, payload: files }),
    removeFile: (index) => dispatch({ type: ACTIONS.REMOVE_FILE, payload: index }),
    updateAudienceContent: (data) => dispatch({ type: ACTIONS.UPDATE_AUDIENCE_CONTENT, payload: data }),
    updateBudgetData: (data) => dispatch({ type: ACTIONS.UPDATE_BUDGET_DATA, payload: data }),
    setCurrentStep: (step) => dispatch({ type: ACTIONS.SET_CURRENT_STEP, payload: step }),
    reset: () => dispatch({ type: ACTIONS.RESET })
  };

  // 辅助方法
  const utils = {
    getFilesInfo: () => state.campaignInfo.files.map(f => ({
      name: f.name,
      type: f.type,
      size: f.size
    })),
    
    getValidFiles: () => state.campaignInfo.files.filter(f => f instanceof File),
    
    getTotalFileSize: () => state.campaignInfo.files.reduce((total, file) => total + file.size, 0),
    
    getFormattedFileSize: (bytes) => {
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      if (bytes === 0) return '0 Bytes';
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return Math.round(bytes / Math.pow(1024, i) * 100) / 100 + ' ' + sizes[i];
    }
  };

  console.log('🌍 CampaignContext 状态更新:', {
    filesCount: state.campaignInfo.files.length,
    currentStep: state.currentStep,
    totalSize: utils.getFormattedFileSize(utils.getTotalFileSize())
  });

  return (
    <CampaignContext.Provider value={{ state, actions, utils }}>
      {children}
    </CampaignContext.Provider>
  );
};

// Hook for using context
export const useCampaign = () => {
  const context = useContext(CampaignContext);
  if (!context) {
    throw new Error('useCampaign must be used within a CampaignProvider');
  }
  return context;
};

export { ACTIONS }; 